import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchSummaryFundamentals } from '@apis/performance';
import type { FundamentalsApiItem } from '@app-types/summaryApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

/**
 * React Query hook for the Investment Indicators (GET /api/summary/fundamentals).
 * Reads ticker/mkt from the router location so URL changes refetch.
 */
export const useSummaryFundamentals = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<FundamentalsApiItem[]>({
    queryKey: ['summary', 'fundamentals', ticker, mkt],
    queryFn: () => fetchSummaryFundamentals({ ticker: ticker as string, mkt: mkt as string }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};
